import {Component, OnInit, Input, Output, EventEmitter, AfterViewInit} from "@angular/core";
import {UserAuthService} from "../user-auth.service";
import {Router, ActivatedRoute} from "@angular/router";

import {LoginUserService} from '../../../core/services/login-user.service';
import {MessageService} from '../../../core/services/message.service';
import {log} from "util";

declare var returnCitySN;

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"]
})
export class RegisterComponent implements OnInit, AfterViewInit {
  username: string;
  password: string;
  repassword: string;
  email: string;
  verifyCode: string;
  sID: string;
  public ip: string = null;
  public regCode: string;
  public timeCode: number = 0;
  errorColor: boolean = false;
  picCode: string = '';
  picDom: any;
  token: string;

  constructor(
    private _service: UserAuthService,
    private _msg: MessageService,
    private _router: Router,
    private _login: LoginUserService,
  ) {
  }

  ngOnInit() {
    if (returnCitySN['cip']) {
      this.ip = returnCitySN['cip'];
    }
    this._service.checkStatus().then(resp => {
    });
  }

  ngAfterViewInit(): void {
    this.picDom = document.getElementById('pic-code');
    this.getPicCode();
  }

  regUsername() {
    // let mobile_reg = new RegExp(/^0{0,1}(13[0-9]|15[0-9]|153|156|173|177|178|18[0-9]|19[0-9])[0-9]{8}$/);
    let mobile_reg = new RegExp(/^[1]\d{10}$/);
    let email_reg = new RegExp(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/);
    if (!this.username) {
      this._msg.warn('请输入手机号或邮箱');
      setTimeout(() => {
        this._msg.clear();
      }, 3000);
    } else if (!mobile_reg.test(this.username.trim()) && !email_reg.test(this.username.trim())) {
      this._msg.warn('用户名格式不正确！!');
      this.errorColor = true;
      setTimeout(() => {
        this._msg.clear();
      }, 3000);
      return false;
    } else {
      this.errorColor = false;
      return true;
    }
  }

  getPicCode() {
    this._service.getPicCode().then(resp => {
      this.picDom.style.backgroundImage = `url('${resp.img_data}')`;
      this.token = resp.token;
    });
  }
  //获取验证吗
  getRegCode() {

    if (this.picCode.trim().length <= 0) {
      return false;
    }
    if (!this.regUsername()) {
      return false;
    }
    if (this.timeCode === 0) {
      this._service.getCode({
        username: this.username.trim(),
        piccode: this.picCode,
        token: this.token
      }).then(resp => {
        if (resp['data'] && resp['data']['success']) {
          if (resp['data']['sId']) {
            this.timeCode = 60;
            this.getTimeCode();
            this.sID = resp['data']['sId'];
            this._msg.success(resp['data']['message']);
            setTimeout(() => {
              this._msg.clear();
            }, 3000);
          }
        }
      });
    }

  }

  //验证倒计时
  getTimeCode() {
    if (this.timeCode > 0) {
      this.timeCode--;
      setTimeout(() => {
        this.getTimeCode();
      }, 1000);
    } else {
      this.timeCode = 0;
    }
  }

  //注册成功
  register() {
    if (this.username && this.password && this.repassword && this.sID && this.verifyCode && this.ip) {
      this._service.register(this.username.trim(), this.password, this.repassword, this.sID, this.verifyCode, this.ip)
        .then(resp => {
          if (resp['data']) {
            this._msg.success(resp['data']['msg']);
            if (resp['data']['uchead']) {
              resp['data']['user']['uchead'] = resp['data']['uchead'];
            }
            this._login.setLogin(resp['data']['user']);
            //是否第一次登录，或信息是否完善判断函数
            this._router.navigate(['/user-info/user-complete']);
            setTimeout(() => {
              this._msg.clear();
            }, 3000);
          }
        });
    } else {
      this._msg.warn("请完善信息");
      setTimeout(() => {
        this._msg.clear();
      }, 3000);
    }
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/user-auth/register/register.component.ts